import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'

export const usePatchBookingApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(
    async ({bookingUuid, availabilityId, productId, optionId, unitItems}: Params.PatchBooking) => {
      const {data} = await ventrata.patch<Ventrata.Booking>(
        `/bookings/${bookingUuid}`,
        {
          unitItems,
          productId,
          optionId,
          availabilityId,
        },
        {
          headers: {
            'Octo-Capabilities': 'octo/cardPayments,octo/questions',
          },
        }
      )

      return data
    },
    [ventrata]
  )
}
